import { SelectInput } from "components/FormControls/Select/Select";
import { useMessage } from "hooks/intl";
import { TransactionItem } from "types/campaigns";

interface Props {
  transactionItemsFilters?: TransactionItem[];
  fieldKey: string;
}

export const TransactionFilterParam = ({
  fieldKey,
  transactionItemsFilters,
}: Props) => {
  const { message } = useMessage();

  return (
    <SelectInput
      label={message({
        id: "selectSetOfTransactionFilters",
      })}
      name={`${fieldKey}.value.filterCode`}
      items={
        transactionItemsFilters?.map((item) => ({
          id: item.code,
          label: item.name,
        })) || []
      }
      data-test-id="transaction-filters-set"
    />
  );
};
